import { Component } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
export interface errorModel {
  title:string;
  message:string;
  question:string;
}
@Component({
    selector: 'confirm',
    template: `<div class="modal-dialog small-model">
    <div class="modal-content">
       <div class="modal-header">
         <button type="button" class="close" (click)="close()">&times;</button>
         <h4 class="modal-title">{{title || 'ERROR'}}</h4>
       </div>
       <div class="modal-body">
       <p class="modal-message linebreak" [innerHTML]="message"></p>
       <hr class="hr-grey">
       </div>

       <div class="modal-footer">
       <button type="button" class="btn btn-default" (click)="clearAll()" >Clear All</button>
         <button type="button" class="btn btn-primary" (click)="confirm()">{{question}}</button>
       </div>
     </div>
    </div>`
})
export class errorComponent extends DialogComponent<errorModel, boolean> implements errorModel {
  title: string;
  message: string;
  question:string;
  constructor(dialogService: DialogService) {
    super(dialogService);
  }
  confirm() {
    // we set dialog result as true on click on confirm button,
    // then we can get dialog result from caller code
    this.close();
  }
  clearAll(){
    this.result = false;
    this.close();
  }
}
